<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:PasswordInput
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/06 | 富士通株式会社         | 新規作成
// 01.01.00 | 2024/03/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div :class="[classDiv != '' ? classDiv : '']">
		<input
			v-bind="$attrs"
			ref="passwordInput"
			:type="inputType"
			:value="modelValue"
			:placeholder="placeholder == null ? '' : placeholder"
			:class="['contents__input--text ime-inactive width-password', {'contents__error--item': errorFlg}]"
			:disabled="disabledFlg"
			:maxlength="maxLength"
			:tabindex="tabindex"
			@input="$emit('update:modelValue', $event.target.value)"
			@keydown.delete.stop="keyControl"
			@blur="$emit('blur', $event)"
			@keydown="$emit('keydown', $event)"
			@paste="paste"
		>
		<!-- <span class="iconType"> -->
		<span>
			<!-- <font-awesome-icon
				:icon="iconType"
				@click="onClick"
			/> -->
			<a href="#" class="icon_color" @click.prevent.stop="onClick()" tabindex="-1">
				<font-awesome-icon 
					:icon="iconType"
					:class="['iconType']"	
				/>
			</a>
		</span>
	</div>
</template>

<script>
import { co_checkLength, co_isEmpty } from '@/common/checkUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_trim } from '@/common/stringUtility.js';

import { TEXTINPUT_TYPE } from '@/const/const.js';
import { STORE_ERROR_SET_INPUT_ERR, STORE_ERROR_IS_ERRFLG } from '@/const/store.js';

export default {
	inheritAttrs: false,
	props: {
		modelValue: {type: String, default: ''},					// 項目値
		name: {type: String, default: ''},							// 項目名
		requireFlg: { type: Boolean, default: false },				// true : 必須
		textType: { type: Number, default: TEXTINPUT_TYPE.ALL },
		maxLength: { type: Number, default: 0 },					// 最大文字数
		placeholder: { type: String, default: null },				// 入力補助
		disabledFlg: { type: Boolean, default: false },				// 活性・非活性フラグ
		tabindex: {type: Number, default: 0},						// タブインデックス
		groupId: {type: String, default: ''},						// 項目グループID
		formatCheckFlg: { type: Boolean, default: false },			// パスワード形式チェックフラグ
		pasteBanFlg: { type: Boolean, default: false },				// ペースト可否フラグ
		classDiv: {type: String, default: ''},						// コントロールエリアのスタイル
	},
	emits: ['update:modelValue', 'blur', 'keydown'],
	data: function () {
		return {
			isChecked: false,
			errorFlg: false,
		}
	},
	computed: {
		inputType: function () {
			return this.isChecked ? "text" : "password";
		},
		iconType: function () {
			return this.isChecked ? "eye" : "eye-slash";
		},
		errFlg: function () {
			return this.$store.getters[STORE_ERROR_IS_ERRFLG];
		}
	},
	watch: {
		disabledFlg: function( val ) {
			if( val ) {
				this.clearError();
			}
		},
		errFlg: function(newValue) {
			if(newValue === false) {
				this.clearError();
			}
		}
	},
	methods: {
		keyControl: function () {
			// キーイベントを無効化するためのメソッドのため、処理なし
		},
		// パスワード表示・非表示
		onClick: function() {
			this.isChecked = !this.isChecked;
		},
		// 妥当性チェック
		validate: function () {
			// TRIM処理
			let value = co_trim(this.modelValue);
			this.$emit('update:modelValue', value);

			let error = false;

			// 必須チェック
			if ( this.requireFlg === true ) {
				if ( co_isEmpty(value) ) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR,
									{id: this.groupId, msg: co_getMessage('E0053', this.name)});
					error = true;
				}
			}


			if ( !co_isEmpty(value) ) {
				// 最大入力文字チェック
				if ( !co_checkLength(value, this.maxLength) ) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR,
									{id: this.groupId, msg: co_getMessage('E0055', this.name, String(this.maxLength))});
					error = true;
				}

				// 半角数字、半角英小文字、半角英大文字のいずれかがなく、8～14文字でない場合エラー
				if( this.formatCheckFlg && !value.match(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,14}$/) ) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR,
									{id: this.groupId, msg: co_getMessage('E0006', this.name)});
					error = true;
				}
			}

			this.errorFlg = error;
			return !this.errorFlg;
		},
		// エラー設定
		setError: function() {
			this.errorFlg = true;
		},
		// エラークリア
		clearError: function() {
			this.errorFlg = false;
		},
		// フォーカス設定
		focus: function() {
			this.$refs.passwordInput.focus();
		},
		// ペースト処理
		paste: function (event) {
			if (this.pasteBanFlg) {
				// ペースト不可の場合、ペースト処理中止
				event.preventDefault();
			}
			
		},
	}
}
</script>

<style scoped>
.width-password {
		width: 48%;
}
.iconType {
	position: absolute;
	float: right;
	left: 45%;
	top: 37%;
}

.icon_color {
	color: #262626;
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.width-password {
		width: 94%;
	}
	.iconType {
		position: absolute;
		float: right;
		left: 86%;
		top: 26%;
	}
}
</style>